import { render, staticRenderFns } from "./PracticeInfoPreview.vue?vue&type=template&id=4c0ba092&scoped=true"
import script from "./PracticeInfoPreview.vue?vue&type=script&lang=js"
export * from "./PracticeInfoPreview.vue?vue&type=script&lang=js"
import style0 from "./PracticeInfoPreview.vue?vue&type=style&index=0&id=4c0ba092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ba092",
  null
  
)

export default component.exports